module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-requests-list text-dark",
    class: {
      'user-requests-list--user': _vm.isUserView
    }
  }, [(!_vm.isUserView) ? _c('h1', [_vm._v(_vm._s(_vm.i18n['absence_requests']))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-requests-list__toolbar marg-1-bottom"
  }, [_c('Tabs', {
    attrs: {
      "selected": _vm.selectedTab,
      "tabs": _vm.tabs
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n['school_year'],
      "tags": _vm.schoolYearTags,
      "selectedTags": _vm.selectedSchoolYears
    },
    on: {
      "select": _vm.toggleSchoolYear,
      "clear": function($event) {
        _vm.selectedSchoolYears = []
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : _c('table', {
    staticClass: "do-table"
  }, [_c('thead', {
    staticClass: "do-table__header"
  }, [_c('tr', [_c('th', {
    staticClass: "th-sorter td-created",
    class: {
      'th-sorter--active': _vm.sortBy === 'created_at'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('created_at')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('created_at')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['created']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'vUserName'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vUserName')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('vUserName')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['who']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'start_time'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('start_time')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('start_time')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['from']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'end_time'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('end_time')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('end_time')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['to']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'vSubjectTitle'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vSubjectTitle')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('vSubjectTitle')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['reason']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'request_note'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('request_note')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('request_note')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['note']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'response_note'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('response_note')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('response_note')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['note_back']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'vResponderName'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vResponderName')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('vResponderName')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['answered_by']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'requested') ? _c('th') : _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'state'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('state')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.setSort('state')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['status']) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })])])]), _vm._v(" "), _c('tbody', [(_vm.sortedRequests.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic text-align-left",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.emptyTableTitle) + "\n      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedRequests), function(request) {
    return _c('tr', {
      key: request.id,
      on: {
        "click": function($event) {
          return _vm.setTheEditRequest(request)
        }
      }
    }, [_c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
      }],
      staticClass: "td-created",
      attrs: {
        "content": request.vCreated
      }
    }, [_vm._v("\n        " + _vm._s(request.vCreatedTimeAgo) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(request.vUserName))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(request.vStart))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(request.vEnd))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "do-pill do-pill--white"
    }, [_vm._v(_vm._s(request.vSubjectTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "italic"
    }, [_vm._v(_vm._s(request.request_note))]), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', {
      staticClass: "italic"
    }, [_vm._v(_vm._s(request.response_note))]) : _vm._e(), _vm._v(" "), (_vm.selectedTab !== 'requested') ? _c('td', [_vm._v(_vm._s(request.vResponderName))]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.isUserView && _vm.selectedTab === 'requested') ? _c('button', {
      staticClass: "do-bttn",
      on: {
        "click": function($event) {
          _vm.theAnswerRequest = request
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.i18n['answer']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isUserView && request.state === 'requested') ? _c('div', {
      staticClass: "d-bagde d-badge--yellow"
    }, [_vm._v("\n          " + _vm._s(_vm.i18n['pending']) + "\n        ")]) : (request.state === 'approved') ? _c('div', {
      staticClass: "d-bagde d-badge--green"
    }, [_vm._v("\n          " + _vm._s(_vm.i18n['approved']) + "\n        ")]) : _vm._e(), _vm._v(" "), (request.state === 'rejected') ? _c('div', {
      staticClass: "d-bagde"
    }, [_vm._v("\n          " + _vm._s(_vm.i18n['rejected']) + "\n        ")]) : _vm._e()])])
  })], 2)]), _vm._v(" "), (_vm.theAnswerRequest) ? _c('UserRequestListAnswer', {
    attrs: {
      "request": _vm.theAnswerRequest
    },
    on: {
      "submitted": _vm.onSubmittedAnswer,
      "close": _vm.onCloseAnswerRequest
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theEditRequest) ? _c('UserRequestForm', {
    attrs: {
      "editRequest": _vm.theEditRequest
    },
    on: {
      "submitted": _vm.onSubmittedAnswer,
      "close": function($event) {
        _vm.theEditRequest = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47649dd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestList.vue
// module id = 1893
// module chunks = 1